import './app-signin.css'
import React, { useState } from 'react'
import Box from '@mui/material/Box'
import InputText from '../../components/InputText'
import Button from '../../components/Button'
import NavigationConstants from '../BenefitsApplication/shared/enums/navigation'
import { useHistory } from 'react-router-dom'
import BackButton from '../../components/BackButton'
import CustomModal from '../Modal/CustomModal'
import { Typography } from '@mui/material'
import { Credentials } from '../model/Credentials'
import AppSignInService from './service/AppSignInService'
import ErrorSummary from '../../components/ErrorSummary'
import { getBaseUrl } from '../../utils/url-constant'

const AppSignInPage = (props: any) => {
  const history = useHistory()
  const [localState, setloginRepState] = useState<Credentials>({
    userName: '',
    password: '',
  })
  const [openAgreementModal, setOpenAgreementModal] = useState(false)
  const [isShowPassword, setShowPassword] = useState(false)
  const [loginError, setLoginError] = useState('')
  const [userNameError, setUserNameError] = useState('')
  const [passwordError, setPasswordError] = useState('')

  sessionStorage.removeItem('access_token')
  sessionStorage.removeItem('orgId')
  sessionStorage.removeItem('token_type')
  sessionStorage.removeItem('member_id')
  sessionStorage.removeItem('isIdProofed')

  const routeChange = () => {
    resetLoginErrorMsgs()

    if (loginValidationFormWithErrorMsg()) {
      let data = {
        userName: localState.userName,
        password: localState.password,
      }
      AppSignInService.appSignIn(data)
        .then((response) => {
          console.log(response.data)
          if (response.data && response.data.orgStatus == 'AP') {
            sessionStorage.setItem('access_token', response.data.access_token)
            sessionStorage.setItem('orgId', response.data.orgId)
            sessionStorage.setItem('token_type', response.data.token_type)
            const path = NavigationConstants.ApiLandingPage
            history.push(path)
          } else {
            setLoginError('User is not approved. please contact admin')
          }
        })
        .catch((e) => {
          setLoginError(e.message)
          console.log(e.message)
        })
    }
  }

  const signupRoute = () => {
    const path = NavigationConstants.OrganizationUserSecurityHomePage
    history.push(path)
  }

  const handleCloseBtnAgreementModal = () => {
    setOpenAgreementModal(false)
  }

  const showPassword = () => {
    setShowPassword(!isShowPassword)
  }

  const handleOpenAgreementModal = () => {
    setOpenAgreementModal(true)
  }
  const handleAdditionalChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setloginRepState({
      ...localState,
      [event.target.name]: event.target.value,
    })
  }

  const resetLoginErrorMsgs = () => {
    setLoginError('')
    setUserNameError('')
    setPasswordError('')
  }

  const loginValidationFormWithErrorMsg = () => {
    let isFormValid = true

    if (!localState.userName) {
      setUserNameError('Please enter User Name field')
      isFormValid = false
    }

    if (!localState.password) {
      setPasswordError('Please enter Password field')
      isFormValid = false
    }

    return isFormValid
  }

  const errorMessages = [loginError, userNameError, passwordError]

  // TO-DO Handle error messages
  const cleanedErrorMsgs = (errorMessages || []).filter((msg) => !!msg)
  return (
    <React.Fragment>
      <div className="header">
        <a className="logo" href={getBaseUrl()}>
          <h1 style={{ margin: 15 }}> CMSI </h1>
          {/* <svg width="156" height="62" viewBox="0 0 156 62" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.7457 28.7969V52.4154H17.6882L2.5058 33.2516V52.4154H0V28.7969H2.06589L17.2844 47.9607V28.7969H19.7457Z" fill="white"></path><path d="M42.3864 44.2828H27.5409C27.8193 47.9942 30.6453 50.4582 34.5265 50.4582C36.6843 50.4582 38.6082 49.6814 39.9585 48.1306L41.3089 49.6814C39.7219 51.5719 37.2578 52.5854 34.4597 52.5854C28.9247 52.5854 25.1465 48.8044 25.1465 43.5422C25.1465 38.28 28.8244 34.5325 33.8165 34.5325C38.8087 34.5325 42.4198 38.2104 42.4198 43.5422C42.4198 43.751 42.3864 44.0127 42.3864 44.2828ZM27.5409 42.4953H40.1256C39.8221 39.0206 37.2913 36.59 33.8165 36.59C30.3418 36.59 27.8444 39.0179 27.5409 42.4953Z" fill="white"></path><path d="M65.2977 43.5422C65.2977 48.9074 61.5196 52.5853 56.4578 52.5853C53.5233 52.5853 51.0592 51.3018 49.6087 48.9074V52.4155H47.3145V27.3798H49.7089V38.0433C51.1929 35.7463 53.6235 34.5324 56.4578 34.5324C61.5196 34.5324 65.2977 38.1825 65.2977 43.5422ZM62.9033 43.5422C62.9033 39.3909 60.0356 36.6262 56.288 36.6262C52.5404 36.6262 49.6755 39.3909 49.6755 43.5422C49.6755 47.6934 52.5098 50.4582 56.288 50.4582C60.0662 50.4582 62.9033 47.6907 62.9033 43.5422Z" fill="white"></path><path d="M79.1217 34.5325V36.8601C78.9185 36.8601 78.718 36.8267 78.5482 36.8267C74.8368 36.8267 72.5761 39.1905 72.5761 43.3724V52.4155H70.1816V34.6689H72.4758V38.1436C73.6006 35.7826 75.8586 34.5325 79.1217 34.5325Z" fill="white"></path><path d="M96.8134 41.4151V52.4155H94.5192V49.648C93.439 51.4717 91.348 52.5854 88.4134 52.5854C84.3986 52.5854 81.9346 50.4916 81.9346 47.4206C81.9346 44.6893 83.6886 42.3951 88.7838 42.3951H94.419V41.3148C94.419 38.2772 92.6984 36.6262 89.3907 36.6262C87.0965 36.6262 84.936 37.4336 83.4854 38.7172L82.4079 36.9297C84.1954 35.4095 86.8264 34.5325 89.6274 34.5325C94.2158 34.5325 96.8134 36.8267 96.8134 41.4151ZM94.419 47.0921V44.1826H88.8506C85.4093 44.1826 84.2956 45.5329 84.2956 47.3538C84.2956 49.4113 85.9494 50.6949 88.7838 50.6949C91.4817 50.6949 93.4724 49.4113 94.419 47.0921Z" fill="white"></path><path d="M100.863 50.3914L101.944 48.5009C103.361 49.6146 105.755 50.4916 108.253 50.4916C111.627 50.4916 113.008 49.3445 113.008 47.5905C113.008 42.9687 101.504 46.6132 101.504 39.5942C101.504 36.693 104.009 34.5325 108.523 34.5325C110.817 34.5325 113.312 35.1756 114.798 36.1863L113.751 38.1102C112.205 37.0811 110.38 36.5506 108.523 36.59C105.315 36.59 103.898 37.8401 103.898 39.5274C103.898 44.319 115.405 40.7079 115.405 47.5236C115.405 50.5863 112.705 52.5854 108.083 52.5854C105.148 52.5854 102.314 51.6387 100.863 50.3914Z" fill="white"></path><path d="M126.407 43.5088L122.23 47.3538V52.4155H119.836V27.3798H122.23V44.3635L132.824 34.68H135.795L128.203 41.9329L136.502 52.4266H133.559L126.407 43.5088Z" fill="white"></path><path d="M153.164 41.4151V52.4155H150.87V49.648C149.79 51.4717 147.699 52.5854 144.764 52.5854C140.746 52.5854 138.285 50.4916 138.285 47.4206C138.285 44.6893 140.039 42.3951 145.134 42.3951H150.77V41.3148C150.77 38.2772 149.049 36.6262 145.741 36.6262C143.447 36.6262 141.287 37.4336 139.836 38.7172L138.758 36.9297C140.546 35.4095 143.177 34.5325 145.978 34.5325C150.566 34.5325 153.164 36.8267 153.164 41.4151ZM150.77 47.0921V44.1826H145.201C141.768 44.1826 140.655 45.5329 140.655 47.3538C140.655 49.4113 142.308 50.6949 145.143 50.6949C147.832 50.6949 149.823 49.4113 150.77 47.0921Z" fill="white"></path><path d="M153.163 57.7471H0.00878906V59.9995H153.163V57.7471Z" fill="#FFC843"></path><path d="M37.4902 20.9457L38.4731 19.0218C40.1603 20.6756 43.1645 21.8895 46.2689 21.8895C50.6874 21.8895 52.6113 20.0325 52.6113 17.7132C52.6113 11.2371 38.0694 15.2074 38.0694 6.47888C38.0694 3.00417 40.7673 0 46.7728 0C49.4401 0 52.2048 0.776798 54.0953 2.09373L53.2601 4.08167C51.3281 2.83256 49.0816 2.15678 46.7812 2.13271C42.4629 2.13271 40.539 4.05383 40.539 6.41763C40.539 12.8937 55.0809 8.9819 55.0809 17.5851C55.0809 21.0598 52.3162 24.0278 46.2772 24.0278C42.719 24.0139 39.2443 22.7666 37.4902 20.9457Z" fill="#FFC843"></path><path d="M76.5944 15.6815H61.7489C62.0273 19.3929 64.8533 21.8569 68.7345 21.8569C70.8923 21.8569 72.8162 21.0801 74.1666 19.5293L75.503 21.0801C73.9299 22.9706 71.4659 23.984 68.6649 23.984C63.1327 23.984 59.3545 20.2031 59.3545 14.9409C59.3545 9.67871 63.0325 5.93115 68.0246 5.93115C73.0167 5.93115 76.6167 9.60911 76.6167 14.9409C76.6167 15.1414 76.5944 15.4114 76.5944 15.6815ZM61.7489 13.894H74.3336C74.0301 10.4193 71.4993 7.98869 68.0246 7.98869C64.5499 7.98869 62.0524 10.4193 61.7489 13.894Z" fill="#FFC843"></path><path d="M90.4626 5.93115V8.25876C90.2593 8.25876 90.0589 8.22535 89.889 8.22535C86.1777 8.22535 83.9169 10.5864 83.9169 14.7711V23.8142H81.5225V6.06479H83.8167V9.54229C84.9303 7.17848 87.1967 5.93115 90.4626 5.93115Z" fill="#FFC843"></path><path d="M110.469 6.06348L102.576 23.8129H100.112L92.252 6.06348H94.7578L101.395 21.179L108.108 6.06348H110.469Z" fill="#FFC843"></path><path d="M128.794 15.6807H113.948C114.227 19.392 117.053 21.8561 120.934 21.8561C123.092 21.8561 125.015 21.0793 126.366 19.5285L127.713 21.0793C126.129 22.9698 123.671 23.9832 120.864 23.9832C115.332 23.9832 111.554 20.205 111.554 14.9428C111.554 9.68067 115.232 5.93311 120.224 5.93311C125.216 5.93311 128.827 9.61106 128.827 14.9428C128.827 15.1405 128.794 15.4106 128.794 15.6807ZM113.948 13.8932H126.533C126.229 10.4185 123.698 7.98786 120.224 7.98786C116.749 7.98786 114.252 10.4185 113.948 13.8932Z" fill="#FFC843"></path><path d="M32.9828 21.84L32.7044 22.9926C31.8598 23.323 31.186 23.5764 30.683 23.7527C30.117 23.9372 29.5242 24.0257 28.929 24.0145C27.9081 24.0145 27.1127 23.7657 26.5429 23.2683C26.2714 23.0331 26.0556 22.7404 25.9111 22.4115C25.7666 22.0826 25.6971 21.7257 25.7076 21.3667C25.7072 21.0611 25.7286 20.7559 25.7717 20.4534C25.8213 20.0975 25.8891 19.7444 25.9749 19.3954L27.0134 15.659C27.1081 15.3026 27.1888 14.963 27.2529 14.6428C27.3094 14.3539 27.3373 14.0601 27.3364 13.7657C27.3364 13.2896 27.2389 12.9555 27.0413 12.769C26.8436 12.5824 26.4844 12.4906 25.9276 12.4906C25.6444 12.4924 25.363 12.5356 25.0923 12.6186C24.8139 12.7022 24.5605 12.7829 24.3545 12.8609L24.6329 11.7082C25.3262 11.4298 25.986 11.1875 26.6181 10.9871C27.1977 10.7952 27.8034 10.6938 28.4139 10.6864C29.4311 10.6864 30.2144 10.9314 30.7638 11.4214C31.0359 11.6586 31.2519 11.9532 31.3963 12.2839C31.5408 12.6147 31.61 12.9734 31.599 13.3342C31.599 13.4957 31.5795 13.7824 31.5406 14.1917C31.5068 14.569 31.4359 14.942 31.329 15.3054L30.2765 19.0307C30.1823 19.3672 30.1051 19.7082 30.0454 20.0525C29.9885 20.3399 29.954 20.6312 29.9424 20.924C29.9424 21.4196 30.0538 21.7565 30.2765 21.9346C30.6195 22.1496 31.0231 22.2473 31.4264 22.2131C31.7206 22.207 32.0127 22.162 32.2951 22.0794C32.5303 22.0179 32.7602 21.9378 32.9828 21.84ZM33.2612 6.21771C33.2647 6.53067 33.2006 6.8407 33.0733 7.12661C32.9459 7.41251 32.7584 7.66756 32.5234 7.87433C32.0458 8.32606 31.4099 8.57205 30.7526 8.55924C30.093 8.57126 29.4548 8.32555 28.9735 7.87433C28.7376 7.66818 28.5492 7.41331 28.4214 7.12731C28.2935 6.84131 28.2292 6.53097 28.2329 6.21771C28.2291 5.9024 28.2932 5.58995 28.421 5.30167C28.5488 5.01339 28.7373 4.75605 28.9735 4.54718C29.4536 4.09342 30.0922 3.84558 30.7526 3.85669C31.4107 3.84539 32.0467 4.09341 32.5234 4.54718C32.7573 4.75731 32.9435 5.01515 33.0693 5.30332C33.1952 5.5915 33.2578 5.9033 33.2529 6.21771H33.2612Z" fill="white"></path></svg> */}
        </a>
      </div>
      <div className="headerbottombar"></div>
      <div className="subheading grid-row">
        <div className="grid-col flex-1">
          <BackButton />
        </div>
      </div>
      <Box sx={{ m: 20, maxWidth: '550px', margin: '30px auto' }}>
        <Box sx={{ m: 6 }}>
          <Typography variant="h4" gutterBottom component="div">
            Sign In
          </Typography>
          <div className="margin-top-5">
            {cleanedErrorMsgs.length > 0 && (
              <div className="margin-bottom-3 usa-form">
                <ErrorSummary errorMessages={cleanedErrorMsgs} />
              </div>
            )}
          </div>
          <InputText
            context="appSigIn"
            name="userName"
            label="User Name"
            value={localState?.userName}
            onChange={handleAdditionalChange}
            // errorMsg={orgNameErrorMsg}
          />
          <InputText
            context="appSigIn"
            name="password"
            label="Password"
            value={localState?.password}
            type={isShowPassword ? 'text' : 'password'}
            onChange={handleAdditionalChange}
            // errorMsg={orgNameErrorMsg}
          />
          <Box>
            <a href="#" onClick={showPassword}>
              Show Password
            </a>
          </Box>
          <Button
            className="margin-top-3 margin-bottom-2"
            type="submit"
            name="login"
            onClick={routeChange}
          >
            Sign In
          </Button>
          {/* <Box>
                        <a href="#" >Forgot Password?</a>
                    </Box>  */}
          {/* <br/>
                    <Box>
                       Don't have an account? <a href="#" onClick={handleOpenAgreementModal}>Create your account</a>
                    </Box> */}
          <CustomModal
            showPopup={openAgreementModal}
            okButtonText="I Agree"
            headerText="Agreement"
            closeButtonText="Cancel"
            agreeBtnOnClick={signupRoute}
            closeBtnOnClick={handleCloseBtnAgreementModal}
          />
        </Box>
      </Box>
      <div className="text-center footer-text">
        <p>This is a government computer system.</p>
        <p>
          Unauthorized access, use, misuse, or modification of this computer
          system or of the data contained herein or in transit to/from this
          system constitutes a violation of Title 18, United States Code,
          Section 1030, and may subject the individual to Criminal and Civil
          penalties pursuant to Title 26, United States Code, Sections 7213(A),
          7213A (the Taxpayer Browsing Protection Act), 7431 and Health
          Insurance Portability and Accountability Act of 1996. If monitoring
          reveals possible evidence of criminal activity, such evidence may be
          provided to Law Enforcement Personnel. Additional information may be
          found at the Nebraska DHHS System Website Disclaimer under
          'Disclaimer'.
        </p>
      </div>
      <div className="footer">
        <span className="text-center footer-text">Copyright © OCIO 2021</span>
      </div>
    </React.Fragment>
  )
}
export default AppSignInPage
